import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import ContainerEditor from './ContainerEditor';

interface RuleRow {
  id: number | null; container_id: number; container_name: string; column_name?: string;
  component_type?: string; component_name?: string; is_required?: boolean;
  min_instances?: number; max_instances?: number;
}

export default function TemplatePlacementRules({ templates }: { templates: Array<{ id?: number; name: string }> }) {
  const [templateId, setTemplateId] = useState<number | null>(null);
  const [rows, setRows] = useState<RuleRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [editing, setEditing] = useState<number | null>(null);
  const [version, setVersion] = useState(0);
  useEffect(() => { if (!templateId && templates[0]?.id) setTemplateId(templates[0].id); }, [templates, templateId]);
  useEffect(() => {
    if (!templateId) return;
    let disposed = false;
    setLoading(true); setError('');
    api.get(`/api/admin/html-templates/${templateId}/component-rules`)
      .then(response => { if (!disposed) setRows(response.data); })
      .catch(() => { if (!disposed) { setRows([]); setError('Не удалось загрузить правила. Повторите загрузку.'); } })
      .finally(() => { if (!disposed) setLoading(false); });
    return () => { disposed = true; };
  }, [templateId, version]);
  const containers = Array.from(new Set(rows.map(row => row.container_id))).map(id => ({ id, rows: rows.filter(row => row.container_id === id) }));
  return <section className="admin-section">
    <div className="admin-section-header"><h2>Правила размещения компонентов</h2><p>Выберите шаблон и настройте допустимые блоки в его контейнерах.</p></div>
    <div className="u2-toolbarGroup">
      <label className="u2-field">Шаблон<select className="u2-select" value={templateId || ''} onChange={event => setTemplateId(Number(event.target.value))}>
        <option value="" disabled>Выберите шаблон</option>{templates.map(template => <option key={template.id} value={template.id}>{template.name}</option>)}
      </select></label>
      <button className="u2-btn is-secondary" type="button" disabled={loading} onClick={() => setVersion(v => v + 1)}>Обновить</button>
    </div>
    <p className="u2-muted">Правила относятся к контейнеру и действуют во всех шаблонах, где он используется.</p>
    {error && <p role="alert">{error}</p>}
    {loading ? <p role="status">Загрузка правил…</p> : <div className="u2-grid" style={{ gap: 14 }}>
      {!containers.length && !error && <p>В этом шаблоне ещё нет контейнеров. Добавьте их в конструкторе шаблонов.</p>}
      {containers.map(container => <article className="u2-card" key={container.id}><div className="u2-cardInner">
        <div className="u2-row" style={{ flexWrap: 'wrap', gap: 12 }}><div><h3>{container.rows[0].container_name}</h3>{container.rows[0].column_name && <p className="u2-muted">{container.rows[0].column_name}</p>}</div>
          <button className="u2-btn is-primary" type="button" onClick={() => setEditing(container.id)}>Изменить правила</button></div>
        <ul>{container.rows.filter(row => row.id).map(row => <li key={row.id}>{row.component_name || row.component_type} · {row.is_required ? 'обязательный' : 'дополнительный'} · от {row.min_instances} до {row.max_instances} блоков</li>)}</ul>
      </div></article>)}
    </div>}
    {editing !== null && <ContainerEditor containerId={editing} initialTab="components" onClose={() => { setEditing(null); setVersion(v => v + 1); }} onSave={() => { setEditing(null); setVersion(v => v + 1); }} />}
  </section>;
}
